import Colors from '@dynatrace/strato-design-tokens/colors';

import { GridColumns } from '../../../core/components/grid/GridColumns.js';
import { GridRows } from '../../../core/components/grid/GridRows.js';
import {
  getHorizontalNumTicks,
  getVerticalNumTicks,
} from '../../../core/utils/ticks.js';
import type { CategoricalValueScales } from '../../types/categorical-bar-chart.js';
import { isVertical } from '../../utils/layout.js';

interface GridLayoutProps {
  layout: 'horizontal' | 'vertical';
  scale: CategoricalValueScales;
  width: number;
  height: number;
}

export const GridLayout = ({
  layout,
  scale,
  width,
  height,
}: GridLayoutProps) => {
  const vertical = isVertical(layout);

  const Grid = vertical ? GridRows : GridColumns;
  const gridLayoutProps = {
    numTicks: vertical
      ? getVerticalNumTicks(height)
      : getHorizontalNumTicks(width),
  };
  const gridProps = {
    scale,
    width,
    height,
    stroke: Colors.Background.Field.Neutral.DefaultActive,
    ...gridLayoutProps,
  };

  return <Grid {...gridProps} />;
};

GridLayout['displayName'] = 'GridLayout';
